<div class="fullheader">
    <span>
        <img src="../../../assets/images/header-left-logo.svg" alt="J&J MedTech" class="header-logo" />
    </span>
    <span>
        <img src="../../../assets/images/header-right-beta-logo.svg" alt="AiAdvisor" class="header-logo" />
    </span>
</div>